
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';
import $ from "jquery";


class RecentInsightsGlobal {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);
		this.gsap();
		this.recentInsightsSlider();
	}

	gsap() {
		gsap.from('.logos-slider .title',
			{
				scrollTrigger: {
					trigger: '.logos-slider',
				},
				y: 30,
				duration: .5,
			});
		gsap.from('.logos-slider .description',
			{
				scrollTrigger: {
					trigger: '.logos-slider',
				},
				y: 20,
				duration: .5,
			});

	}

	recentInsightsSlider = () => {
		$('.insights-slider').slick({
			autoplay: false,
			infinite: false,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplaySpeed: 1000,
			mobileFirst: true,
			prevArrow: $('.recent-insights__prev'),
			nextArrow: $('.recent-insights__next'),
			responsive: [
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				}
			]
		});
	}
}

new RecentInsightsGlobal();
